<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import { merge } from 'lodash';

export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  watch: {
    value(data) {
      this.data.value = data;
    },
  },
  data() {
    return {
      init: {
        xAxis: {
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          axisLine: {
            show: false,
          },
        },
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
      data: {
        value: this.value,
      },
    };
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.isDark;
    },
    options() {
      const options = {
        title: {
          text: '',
          textStyle: {
            fontSize: 15,
            color: this.isDark ? '#ddd' : '#6b717d',
          },
          x: 'center',
          y: 'top',
        },
        yAxis: {
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            color: ['#777777'],
            type: 'liquidFill',
            radius: '55%',
            amplitude: '5%',
            waveAnimation: true,
            shape: this.shape || 'roundRect', // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'. Or, an SVG path starting with 'path://'
            center: ['50%', '45%'],
            backgroundStyle: {
              color: this.isDark ? '#242424' : '#f7f7f7',
              borderWidth: 0,
              shadowColor: 'rgba(0, 0, 0, 0.4)',
              shadowBlur: 20,
            },
            outline: {
              show: false,
            },
            label: {
              normal: {
                formatter: param => {
                  const contents = [];
                  contents.push(param.data.data);
                  contents.push(' %');
                  return contents.join('');
                },
                textStyle: {
                  color: this.isDark ? '#ddd' : '#6b717d',
                  fontSize: 20,
                },
              },
            },
            data: [
              {
                data: this.data.value,
                value: this.data.value / 100,
              },
            ],
          },
        ],
      };
      return merge({}, options);
    },
  },
};
</script>
